import { Navigate, Outlet } from "react-router-dom";

function accessTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split(".")[1])) as { exp?: number };
    return typeof payload.exp === "number" && payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  if (!accessTokenExpired(token)) return true;
  return Boolean(localStorage.getItem("refreshToken"));
};

const PrivateRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
